"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation connectCode($connectCode: String!) {
    connectStripe(connectCode: $connectCode)
  }
`;
exports.default = mutation;
//# sourceMappingURL=connectStripe.mutation.js.map